/**
 * Leave a reader's RSVP copy out of a list of events.
 *
 * When a reader taps Going or Interested, the app inserts a SECOND
 * `profile_events` row owned by that reader, so the event shows up on their own
 * profile. Ten readers going to one festival means eleven rows that all look
 * like that festival. Anything that browses or counts events has to drop the
 * ten.
 *
 * `source_event_id` is the exact way to say so, and it is what new copies
 * carry. It is NOT enough on its own:
 *
 *   The column was added on 2026-09-18. Every copy made before that has it
 *   null, which is indistinguishable from "this is an original". The live
 *   database reported 468 events and 468 non-copies on the day the column
 *   shipped -- the filter was seeing nothing at all.
 *
 * So the legacy copies are found by `role` instead, which is exact for them.
 * Every insert path in the app writes `role` explicitly, and only two of them
 * ever write these two values:
 *
 *   'hosting'    seed-events.js:1832, ProfileBlocks.jsx (the host form)
 *   'attending'  AdminEventImporter.jsx (the CSV importer)
 *   'going'      Community.jsx:1029 and :1553 -- an RSVP copy, both paths
 *   'interested' the same two paths
 *
 * `profile_events_role_check` permits exactly those four
 * (20260811000000_live_schema_snapshot.sql:2508), so there is no fifth value to
 * account for. The column is nullable and defaults to 'attending', so a null
 * role is an original and has to be kept -- `role not in (...)` evaluates to
 * NULL for a null role and would silently drop it, which is why the null arm
 * is spelled out.
 *
 * Two `.or()` calls on one query AND together in PostgREST, so this composes
 * with `onlyUpcoming()` and with the search filter rather than replacing
 * either.
 *
 * The same rule is written once more in SQL, for the count functions the
 * browse screens call: `public.event_country_counts()` and
 * `event_region_counts()`, in
 * supabase/migrations/20260918010000_rsvp_copies_predate_the_column.sql. If you
 * change the rule here, change it there in the same commit -- a chip that says
 * 12 above a list of 9 is exactly what the two disagreeing looks like.
 */
export function excludeRsvpCopies(query) {
  return query
    .is('source_event_id', null)
    .or('role.is.null,role.not.in.(going,interested)');
}
